export default {
	propose: 'Створіть власну подію та продавайте\nквитки онлайн за допомогою сервіса teeko!',
	description: 'Неперевершені враження\nпочинаються з купівлі квитка!',
	moreEvents: 'Показати Більше подій',
	search: 'Пошук'
}
